<template>
	<div id="app" class="fadeIn animated" onclick="javascript:void(0)">
		<header :class="width > 1100 ? 'desktop-header-center' : 'mobile-header-center'">
			<!--Logo & Menu Section-->
			<nav class="navbar-center-fullwidth navbar navbar-custom center">
				<div class="container-fluid p-l-r-0">
					<div class="logo-area">
						<router-link class="navbar-brand align-center" to="/index"><img v-if="config" width="210" height="59" :src="baseUrl + config.logo" class="custom-logo" alt="" /></router-link>
					</div>
					<button class="navbar-toggle" type="button" data-toggle="collapse" data-target="#custom-collapse">
						<span class="sr-only">切换导航</span>
						<span class="icon-bar"></span>
						<span class="icon-bar"></span>
						<span class="icon-bar"></span>
					</button>
					<div id="custom-collapse" class="collapse navbar-collapse">
						<div class="" v-if="show">
							<ul class="nav navbar-nav">
								<li class="menu-item" :class="router.indexOf('/index') != -1 ? 'active' : ''" @click="onNav('/index')" v-if="nav[0].status == 1">
									<a href="javascript:;" :title="nav[0].title" onfocus="this.blur();">{{nav[0].title}}</a>
								</li>
								<li class="menu-item" :class="router.indexOf('/member') != -1 ? 'active' : ''" @click="onNav('/member')" v-if="nav[1].status == 1">
									<a href="javascript:;" :title="nav[1].title" onfocus="this.blur();">{{nav[1].title}}</a>
								</li>
								<li class="menu-item" :class="router.indexOf('/committee') != -1 || router.indexOf('/comm_article') != -1 ? 'active' : ''" @click="onNav('/committee')" v-if="nav[2].status == 1">
									<a href="javascript:;" :title="nav[2].title" onfocus="this.blur();">{{nav[2].title}}</a>
								</li>
								<li class="menu-item" :class="router.indexOf('/programme') != -1 || router.indexOf('/article') != -1 ? 'active' : ''" @click="onNav('/programme')" v-if="nav[3].status == 1">
									<a href="javascript:;" :title="nav[3].title" onfocus="this.blur();">{{nav[3].title}}</a>
								</li>
								<li class="menu-item" :class="router.indexOf('/about_us') != -1 ? 'active' : ''" @click="onNav('/about_us')" v-if="nav[4].status == 1">
									<a href="javascript:;" :title="nav[4].title" onfocus="this.blur();">{{nav[4].title}}</a>
								</li>
								<li class="menu-item" :class="router.indexOf('/join_us') != -1 ? 'active' : ''" @click="onNav('/join_us')" v-if="nav[5].status == 1">
									<a href="javascript:;" :title="nav[5].title" onfocus="this.blur();">{{nav[5].title}}</a>
								</li>
								<li class="menu-item" :class="router.indexOf('/contact_us') != -1 ? 'active' : ''" @click="onNav('/contact_us')" v-if="nav[6].status == 1">
									<a href="javascript:;" :title="nav[6].title" onfocus="this.blur();">{{nav[6].title}}</a>
								</li>
								<li class="menu-item" :class="router.indexOf('/opinion') != -1 ? 'active' : ''" @click="onNav('/opinion')" v-if="nav[7].status == 1">
									<a href="javascript:;" :title="nav[7].title" onfocus="this.blur();">{{nav[7].title}}</a>
								</li>
								<li class="menu-item" :class="router.indexOf('/calendar') != -1 ? 'active' : ''" @click="onNav('/calendar')" v-if="nav[8].status == 1">
									<a href="javascript:;" :title="nav[8].title" onfocus="this.blur();">{{nav[8].title}}</a>
								</li>
							</ul>
						</div>
					</div>
					<!-- /.navbar-collapse -->
				</div>
				<!-- /.container-fluid -->
			</nav>
			<!--/Logo & Menu Section-->

		</header>
		<section class="section page-title-section" style="min-height: 500px;">
			<router-view v-if="show" :lang="lang != 'en_US' ? 1 : 2"></router-view>
		</section>
		<!-- Footer Section -->
		<footer class="site-footer" v-if="footer">
			<div class="container">
				<div class="row footer-sidebar">
					<div class="col-md-4">
						<aside id="text-1" class="widget widget_text wow fadeInDown animated" data-wow-delay="0.4s">
							<div class="section-header">
								<h3 class="widget-title">{{footer.config.statement_title}}</h3><span></span></div>
							<div class="textwidget">
								{{footer.config.statement_content}}
							</div>
						</aside>
					</div>
					<div class="col-md-4">
						<aside id="text-2" class="widget widget_text wow fadeInDown animated" data-wow-delay="0.4s">
							<div class="section-header">
								<h3 class="widget-title">{{footer.member[0].category}}</h3><span></span></div>
							<div class="textwidget">
								<p>
									<a v-for="item in footer.member[0].list" :href="item.url" rel="noopener noreferrer" target="_blank" style="display: block;">{{item.title}}</a>
								</p>
							</div>
						</aside>
						<aside id="text-3" class="widget widget_text wow fadeInDown animated" data-wow-delay="0.4s">
							<div class="section-header">
								<h3 class="widget-title">{{footer.member[1].category}}</h3><span></span></div>
							<div class="textwidget">
								<p>
									<a v-for="item in footer.member[1].list" :href="item.url" rel="noopener noreferrer" target="_blank" style="display: block;">{{item.title}}</a>
								</p>
							</div>
						</aside>
						<aside id="text-5" class="widget widget_text wow fadeInDown animated" data-wow-delay="0.4s">
							<div class="section-header">
								<h3 class="widget-title">{{footer.member[2].category}}</h3><span></span></div>
							<div class="textwidget">
								<p>
									<a v-for="item in footer.member[2].list" :href="item.url" rel="noopener noreferrer" target="_blank" style="display: block;">{{item.title}}</a>
								</p>
							</div>
						</aside>
					</div>
					<div class="col-md-4">
						<aside id="text-4" class="widget widget_text wow fadeInDown animated" data-wow-delay="0.4s">
							<div class="section-header">
								<h3 class="widget-title">{{footer.member[3].category}}</h3><span></span></div>
							<div class="textwidget">
								<p>
									<a v-for="item in footer.member[3].list" :href="item.url" rel="noopener noreferrer" target="_blank" style="display: block;">{{item.title}}</a>
								</p>
							</div>
						</aside>
						<aside id="text-6" class="widget widget_text wow fadeInDown animated" data-wow-delay="0.4s">
							<div class="section-header">
								<h3 class="widget-title">{{footer.member[4].category}}</h3><span></span></div>
							<div class="textwidget">
								<p>
									<a v-for="item in footer.member[4].list" :href="item.url" rel="noopener noreferrer" target="_blank" style="display: block;">{{item.title}}</a><br />
								</p>
							</div>
						</aside>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<div class="site-info wow fadeIn animated" data-wow-delay="0.4s">
							<p v-if="lang != 'en_US'">
								<a href="https://wordpress.org">版权归“一带一路”生命科技促进联盟所有</a> | 友情链接:
								<a href="http://www.szgia.org.cn" rel="nofollow">深圳市生命科技产学研资联盟</a>
							</p>
							<p v-else>
								<a href="https://wordpress.org">Copyright belong to the Belt and Road Life Science Economy Alliance</a> | Related Links:
								<a href="http://www.szgia.org.cn" rel="nofollow">Shenzhen Life-Tech Industry Alliance</a>
							</p>
						</div>
					</div>
				</div>

			</div>
		</footer>
		<!--Scroll To Top-->
		<a href="#" class="hc_scrollup"><i class="fa fa-chevron-up"></i></a>
		<!--/Scroll To Top-->
		<div id="trp-floater-ls" onclick="javascript:void(0)" data-no-translation class="trp-language-switcher-container trp-floater-ls-names trp-top-right">
			<div id="trp-floater-ls-current-language" class="trp-with-flags">
				<a v-if="lang != 'en_US'" href="javascript:void(0)" class="trp-floater-ls-disabled-language trp-ls-disabled-language" onclick="void(0)">
					<img class="trp-flag-image" src="../assets/zh_CN.png" width="18" height="12" alt="zh_CN" title="Chinese">Chinese
				</a>
				<a v-else href="javascript:void(0)" class="trp-floater-ls-disabled-language trp-ls-disabled-language" onclick="void(0)">
					<img class="trp-flag-image" src="../assets/en_US.png" width="18" height="12" alt="en_US" title="Chinese">English
				</a>
			</div>
			<div id="trp-floater-ls-language-list" class="trp-with-flags">
				<a href="javascript:void(0)" :class="lang != 'en_US' ? 'trp-floater-ls-disabled-language trp-ls-disabled-language' : ''" @click="onChange('zh_CN')">
					<img class="trp-flag-image" src="../assets/zh_CN.png" width="18" height="12" alt="zh_CN" title="Chinese">Chinese
				</a>
				<a href="javascript:void(0)" :class="lang == 'en_US' ? 'trp-floater-ls-disabled-language trp-ls-disabled-language' : ''" @click="onChange('en_US')">
					<img class="trp-flag-image" src="../assets/en_US.png" width="18" height="12" alt="en_US" title="English">English
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/trp-floater-language-switcher.css";
	import "@/assets/css/trp-language-switcher.css";
	import { getNav, getBottom, getSiteConfig } from '../api/api';
	export default {
		data() {
			return {
				show: false,
				baseUrl: 'http://admin.brlsea.org',
				config: '',
				router: '',
				width: 1200,
				lang: 'zh_CN',
				footer: '',
				nav: [],
				title: ''
			};
		},
		methods: {
			onNav(link) {
				if(link == this.router) {
					return false;
				}
				this.$router.push({
					path: link
				})
			},
			onChange(type) {
				let that = this;
				if(type != this.lang) {
					this.lang = type;
					this.show = false;
					setTimeout(() => {
						that.show = true;
					}, 300)
				}
				this.onGetNav();
				this.onGetBottom()
			},
			onGetBottom() {
				let that = this;
				getBottom({
					lang: this.lang != 'en_US' ? 1 : 2
				}).then(res => {
					if(res.code == 1) {
						that.footer = res.data;
					}
				})
			},
			onGetSiteConfig() {
				let that = this;
				getSiteConfig({
					lang: this.lang != 'en_US' ? 1 : 2
				}).then(res => {
					that.show = true;
					if(res.code == 1) {
						that.config = res.data;
					}
				})
			},
			onGetNav() {
				let that = this;
				getNav({
					lang: this.lang != 'en_US' ? 1 : 2
				}).then(res => {
					if(res.code == 1) {
						that.nav = res.data;
					}
				})
			}
		},
		watch: {
			$route(to, from) {
				this.router = this.$route.path;
				jQuery("html, body").animate({
					scrollTop: 0
				}, 0);
			},
		},
		created() {
			let that = this;
			this.router = this.$route.path;
			this.width = document.body.clientWidth;
			if(this.$route.meta.title) {
				document.title = this.$route.meta.title;
			}
			window.onresize = function() {
				that.width = document.body.clientWidth;
			}
			jQuery(document).ready(function() {
				jQuery(window).scroll(function() {
					if(jQuery(this).scrollTop() > 100) {
						jQuery('.hc_scrollup').fadeIn();
					} else {
						jQuery('.hc_scrollup').fadeOut();
					}
				});
				jQuery('.hc_scrollup').click(function() {
					jQuery("html, body").animate({
						scrollTop: 0
					}, 600);
					return false;
				});
			});
			this.onGetBottom();
		},
		mounted() {
			this.onGetNav();
			this.onGetSiteConfig();
		}
	};
</script>

<style type="text/css">
	#app {}
	
	#body,
	#content {
		min-height: 500px;
	}
	
	@media (max-width: 1100px) {
		.navbar-custom .dropdown-menu {
			border-top: none;
			border-bottom: none;
			box-shadow: none !important;
			border: none;
		}
	}
	
	@media (min-width: 100px) and (max-width: 1100px) {
		.navbar .navbar-nav>.active>a,
		.navbar .navbar-nav>.active>a:hover,
		.navbar .navbar-nav>.active>a:focus {
			color: ;
			background-color: transparent;
		}
		.navbar .navbar-nav>.open>a,
		.navbar .navbar-nav>.open>a:hover,
		.navbar .navbar-nav>.open>a:focus {
			background-color: transparent;
			color: ;
			border-bottom: 1px dotted #4c4a5f;
		}
	}
	/*===================================================================================*/
	/*	NAVBAR
/*===================================================================================*/
	
	.navbar-custom {
		background-color: #fff;
		border: 0;
		border-radius: 0;
		z-index: 1000;
		font-size: 1.000rem;
		transition: background, padding 0.4s ease-in-out 0s;
		margin: 0;
		min-height: 90px;
	}
	
	.navbar a {
		transition: color 0.125s ease-in-out 0s;
	}
	
	.navbar-custom .navbar-brand {
		letter-spacing: 1px;
		font-weight: 600;
		font-size: 2.000rem;
		line-height: 1.5;
		color: #1b1b1b;
		margin-left: 0px !important;
		height: auto;
		padding: 26px 30px 26px 15px;
	}
	
	.site-branding-text {
		float: left;
		margin: 0;
		padding: 13px 50px 13px 0;
	}
	
	.site-title {
		height: auto;
		font-size: 1.875rem;
		line-height: 1.3;
		font-weight: 600;
		margin: 0;
		padding: 0px;
	}
	
	.site-description {
		padding: 0;
		margin: 0;
	}
	
	.navbar-custom .navbar-nav li {
		margin: 0px;
		padding: 0;
	}
	
	.navbar-custom .navbar-nav li>a {
		position: relative;
		color: #1b1b1b;
		font-weight: 600;
		font-size: 0.875rem;
		padding: 35px 17px;
		transition: all 0.3s ease-in-out 0s;
	}
	
	.navbar-custom .navbar-nav li>a>i {
		padding-left: 5px;
	}
	/*Dropdown Menu*/
	
	.navbar-custom .dropdown-menu {
		border-radius: 0;
		padding: 0;
		min-width: 200px;
		background-color: #21202e;
		box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
		position: static;
		float: none;
		width: auto;
		margin-top: 0;
	}
	
	.navbar-custom .dropdown-menu>li {
		padding: 0 10px;
		margin: 0;
	}
	
	.navbar-custom .dropdown-menu>li>a {
		color: #d5d5d5;
		border-bottom: 1px dotted #363544;
		font-weight: 600;
		font-size: 0.875rem;
		padding: 12px 15px;
		transition: all 0.2s ease-in-out 0s;
		letter-spacing: 0.7px;
		white-space: normal;
	}
	
	.navbar-custom .dropdown-menu>li>a:hover,
	.navbar-custom .dropdown-menu>li>a:focus {
		padding: 12px 15px 12px 20px;
	}
	
	.navbar-custom .dropdown-menu>li>a:hover,
	.navbar-custom .dropdown-menu>li>a:focus {
		color: #ffffff;
		background-color: #282737;
	}
	
	.navbar-custom .dropdown-menu .dropdown-menu {
		left: 100%;
		right: auto;
		top: 0;
		margin-top: 0;
	}
	
	.navbar-custom .dropdown-menu.left-side .dropdown-menu {
		border: 0;
		right: 100%;
		left: auto;
	}
	
	.navbar-custom .dropdown-menu .open>a,
	.navbar-custom .dropdown-menu .open>a:focus,
	.navbar-custom .dropdown-menu .open>a:hover {
		background: #282737;
		color: #fff;
	}
	
	.nav .open>a,
	.nav .open>a:hover,
	.nav .open>a:focus {
		border-color: #363544;
	}
	
	.navbar-custom .dropdown-menu>.active>a,
	.navbar-custom .dropdown-menu>.active>a:hover,
	.navbar-custom .dropdown-menu>.active>a:focus {
		color: #fff;
		background-color: transparent;
	}
	
	.navbar-custom .navbar-toggle .icon-bar {
		background: #121213;
		width: 40px;
		height: 2px;
	}
	
	.navbar-toggle .icon-bar+.icon-bar {
		margin-top: 8px;
	}
	/*--------------------------------------------------------------
	Menubar - Media Queries
--------------------------------------------------------------*/
	
	@media (min-width: 1100px) {
		.navbar-collapse.collapse {
			display: block !important;
		}
		.navbar-nav {
			margin: 0;
		}
		.navbar-custom .navbar-nav>li {
			float: left;
		}
		.navbar-header {
			float: left;
		}
		.navbar-toggle {
			display: none;
		}
	}
	
	@media (min-width: 768px) {
		.navbar-custom .navbar-brand {
			padding: 20px 50px 20px 0;
		}
	}
	
	@media (min-width: 1100px) {
		.navbar-transparent {
			background: transparent;
			padding-bottom: 0px;
			padding-top: 0px;
			margin: 0;
		}
		.navbar-custom .open>.dropdown-menu {
			visibility: visible;
			opacity: 1;
		}
		.navbar-right .dropdown-menu {
			right: auto;
			left: 0;
		}
	}
	
	@media (min-width: 1101px) {
		.navbar-custom .container-fluid {
			width: 970px;
			padding-right: 15px;
			padding-left: 15px;
			margin-right: auto;
			margin-left: auto;
		}
		.navbar-custom .dropdown-menu {
			border-top: 2px solid #ce1b28 !important;
			border-bottom: 2px solid #ce1b28 !important;
			position: absolute !important;
			display: block;
			visibility: hidden;
			opacity: 0;
		}
		.navbar-custom .dropdown-menu>li>a {
			padding: 12px 15px !important;
		}
		.navbar-custom .dropdown-menu>li>a:hover,
		.navbar-custom .dropdown-menu>li>a:focus {
			padding: 12px 15px 12px 20px !important;
		}
		.navbar-custom .open .dropdown-menu {
			background-color: #21202e !important;
		}
		.navbar-custom .dropdown-menu>li>a i {
			float: right;
		}
	}
	
	@media (min-width: 1200px) {
		.navbar-custom .container-fluid {
			width: 1170px;
			padding-right: 15px;
			padding-left: 15px;
			margin-right: auto;
			margin-left: auto;
		}
	}
	/** BELOW MAX-WIDTH MEDIA QUERIES **/
	
	@media (max-width: 1100px) {
		/* Navbar */
		.navbar-custom .navbar-nav {
			letter-spacing: 0px;
			margin-top: 1px;
			margin-bottom: 0;
		}
		.navbar-custom .navbar-nav li {
			margin: 0 15px;
			padding: 0;
		}
		.navbar-custom .navbar-nav li>a {
			color: #bbb;
			padding: 12px 0px 12px 0px;
		}
		.navbar-custom .navbar-nav>li>a:focus,
		.navbar-custom .navbar-nav>li>a:hover {
			background: transparent;
			color: #fff;
		}
		.navbar-custom .dropdown-menu>li>a {
			display: block;
			clear: both;
			font-weight: normal;
		}
		.navbar-custom .dropdown-menu>li>a:hover,
		.navbar-custom .dropdown-menu>li>a:focus {
			background-color: #21202F;
			color: #fff;
			padding: 12px 0px 12px 0px;
		}
		.navbar-custom .open .dropdown-menu {
			position: static;
			float: none;
			width: auto;
			margin-top: 0;
			background-color: transparent;
			border: 0;
			-webkit-box-shadow: none;
			box-shadow: none;
		}
		.navbar-custom .open .dropdown-menu>li>a {
			line-height: 20px;
		}
		.navbar-custom .open .dropdown-menu .dropdown-header,
		.navbar-custom .open .dropdown-menu>li>a {
			padding: 12px 0px;
		}
		.navbar-custom .open .dropdown-menu .dropdown-menu .dropdown-header,
		.navbar-custom .open .dropdown-menu .dropdown-menu>li>a {
			padding: 12px 0px;
		}
		.navbar-custom li a,
		.navbar-custom .dropdown-search {
			border-bottom: 1px dotted #4c4a5f !important;
		}
		.navbar-header {
			padding: 0px 15px;
			float: none;
		}
		.navbar-custom .navbar-brand {
			padding: 20px 50px 20px 0px;
		}
		.navbar-toggle {
			display: block;
			margin: 24px 15px 24px 0;
			padding: 9px 0px;
		}
		.site-branding-text {
			padding: 17px 50px 17px 15px;
		}
		.navbar-collapse {
			border-top: 1px solid transparent;
			box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
		}
		.navbar-collapse.collapse {
			display: none!important;
		}
		.navbar-custom .navbar-nav {
			background-color: #21202e;
			float: none!important;
			margin: 0px
		}
		.navbar-custom .navbar-nav>li {
			float: none;
		}
		.navbar-collapse.collapse.in {
			display: block!important;
		}
		.collapsing {
			overflow: hidden!important;
		}
	}
	
	@media (max-width: 1100px) {
		.navbar-custom .dropdown a>i.fa {
			font-size: 0.938rem;
			position: absolute;
			right: 0;
			margin-top: -6px;
			top: 50%;
			padding-left: 7px;
		}
	}
	
	@media (max-width: 768px) {
		.navbar-header {
			padding: 0 15px;
		}
		.navbar-custom .navbar-brand {
			padding: 20px 50px 20px 15px;
		}
	}
	
	@media (max-width: 500px) {
		.navbar-custom .navbar-brand {
			float: none;
			display: block;
			text-align: center;
			padding: 25px 15px 12px 15px;
		}
		.navbar-custom .navbar-brand img {
			margin: 0 auto;
		}
		.site-branding-text {
			padding: 17px 15px 17px 15px;
			float: none;
			text-align: center;
		}
		.navbar-toggle {
			float: none;
			margin: 10px auto 25px;
		}
	}
	/*===================================================================================*/
	/*	CART ICON 
/*===================================================================================*/
	
	.cart-header {
		width: 40px;
		height: 40px;
		line-height: 1.6;
		text-align: center;
		background: transparent;
		position: relative;
		float: right;
		margin: 25px 7px 25px 20px;
	}
	
	.cart-header>a.cart-icon {
		-wekbit-transition: all 0.3s;
		-moz-transition: all 0.3s;
		-o-transition: all 0.3s;
		transition: all 0.3s;
		display: inline-block;
		font-size: 1.125rem;
		color: #202020;
		width: 100%;
		height: 100%;
		border: 1px solid #eaeaea;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		border-radius: 50%;
		padding: 4px;
	}
	
	.cart-header>a .cart-total {
		font-family: 'Open Sans', Sans-serif;
		font-size: 0.688rem;
		line-height: 1.7;
		color: #ffffff;
		font-weight: 600;
		position: absolute;
		right: -7px;
		top: -7px;
		padding: 1px;
		width: 1.225rem;
		height: 1.225rem;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		border-radius: 50%;
		-wekbit-transition: all 0.3s;
		-moz-transition: all 0.3s;
		-o-transition: all 0.3s;
		transition: all 0.3s;
	}
	
	@media (min-width: 100px) and (max-width: 1100px) {
		.cart-header {
			float: left;
			margin: 20px 7px 20px 15px !important;
		}
		.cart-header>a.cart-icon {
			color: #fff;
		}
	}
	/*--------------------------------------------------------------
	Navbar Overlapped & Stiky Header Css
--------------------------------------------------------------*/
	
	body.blog .header-overlapped {
		margin: 0px;
	}
	
	body.page-template-template-business .header-overlapped,
	body.page-template-template-overlaped .header-overlapped {
		background-color: transparent;
		margin: 0;
		position: relative;
		z-index: 99;
	}
	
	.header-overlapped .page-title-section {
		background-color: transparent !important;
	}
	
	.navbar-overlapped {
		position: absolute;
		right: 0;
		left: 0;
		top: 0;
		z-index: 20;
		background-color: rgba(0, 0, 0, 0.2);
	}
	
	@media (min-width:500px) {
		body.page-template-template-business .navbar-overlapped {
			position: absolute;
			right: 0;
			left: 0;
			top: 0;
			z-index: 20;
		}
	}
	
	.navbar-overlapped {
		min-height: 90px;
		position: relative;
	}
	
	.header-overlapped .page-seperate {
		display: none;
	}
	
	.navbar-overlapped .navbar-brand {
		padding: 20px 0px;
		color: #ffffff;
	}
	
	.navbar-overlapped .navbar-brand:hover,
	.navbar-overlapped .navbar-brand:focus {
		color: #ffffff;
	}
	
	.navbar-overlapped .site-title a,
	.navbar-overlapped .site-title a:hover,
	.navbar-overlapped .site-title a:focus,
	.navbar-overlapped .site-description {
		color: #fff;
	}
	
	.navbar-overlapped .navbar-nav>li>a {
		color: #fff;
		border-bottom: 2px solid transparent;
		margin-left: 5px;
		margin-right: 5px;
	}
	
	.navbar-overlapped .navbar-nav>li>a:hover,
	.navbar-overlapped .navbar-nav>li>a:focus {
		background-color: transparent;
		color: #fff;
		border-bottom: 2px solid rgba(255, 255, 255, 1);
	}
	
	.navbar-overlapped .navbar-nav>.open>a,
	.navbar-overlapped .navbar-nav>.open>a:hover,
	.navbar-overlapped .navbar-nav>.open>a:focus {
		background-color: transparent;
		color: #fff;
		border-bottom: 2px solid transparent;
	}
	
	.navbar-overlapped .navbar-nav>.active>a,
	.navbar-overlapped .navbar-nav>.active>a:hover,
	.navbar-overlapped .navbar-nav>.active>a:focus {
		background-color: transparent !important;
		color: #fff;
		border-bottom: 2px solid rgba(255, 255, 255, 1);
	}
	
	.navbar-overlapped .cart-header {
		width: 25px;
		height: 25px;
		margin: 33px 7px 32px 20px;
	}
	
	.navbar-overlapped .cart-header>a.cart-icon {
		color: #fff;
		border: 1px solid #ffffff;
	}
	
	.navbar-overlapped .cart-header>a.cart-icon {
		width: auto;
		height: auto;
		border: 0 none;
		padding: 0;
	}
	
	.navbar-overlapped .cart-header>a .cart-total {
		right: -11px;
		top: -4px;
	}
	/*Header Stiky Menu*/
	
	.stiky-header {
		position: fixed !important;
		top: 0;
		left: 0;
		right: 0;
		z-index: 999;
		background: #21202e;
		transition: all 0.3s ease;
		min-height: 70px;
		box-shadow: 0 2px 3px rgba(0, 0, 0, .1)
	}
	
	.navbar-overlapped.stiky-header .navbar-brand {
		padding: 10px 0px;
	}
	
	.navbar-overlapped.stiky-header .site-branding-text {
		padding: 3px 50px 3px 15px;
	}
	
	.navbar-overlapped.stiky-header .navbar-nav>li>a {
		padding: 24px 10px;
	}
	
	.navbar-overlapped.stiky-header .cart-header {
		margin: 23px 7px 22px 20px;
	}
	/*--------------------------------------------------------------
	Menubar - Media Queries
--------------------------------------------------------------*/
	
	@media (min-width: 768px) {
		.navbar-custom .navbar-brand {
			padding: 20px 50px 20px 0;
		}
	}
	/** BELOW MAX-WIDTH MEDIA QUERIES **/
	
	@media (max-width: 768px) {
		.navbar-custom .navbar-brand {
			padding: 20px 50px 20px 15px;
		}
	}
	
	@media (max-width: 500px) {
		.navbar-custom .navbar-brand {
			float: none;
			display: block;
			text-align: center;
			padding: 20px 15px 25px 15px;
		}
		.navbar-custom .navbar-brand img {
			margin: 0 auto;
		}
		.site-branding-text {
			padding: 17px 15px 17px 15px;
			float: none;
			text-align: center;
		}
		.navbar-toggle {
			float: none;
			margin: 10px auto 25px;
		}
		/*Navbar Overlapped*/
		.navbar-overlapped {
			position: relative;
			background-color: #21202e;
			border-bottom: 1px solid #4c4a5f;
		}
		.navbar-overlapped .navbar-collapse.in {
			bottom: 0px;
		}
		.navbar-overlapped .navbar-collapse {
			bottom: 0px;
		}
		.navbar-overlapped.stiky-header .navbar-toggle {
			float: none;
			margin: 10px auto 25px;
		}
		.navbar-overlapped.stiky-header .site-branding-text {
			padding: 17px 15px 17px 15px;
			float: none;
			text-align: center;
		}
		body.blog .navbar-overlapped {
			position: relative;
		}
	}
	/*--------------------------------------------------------------
	Navbar Classic Header Css
--------------------------------------------------------------*/
	
	.navbar-classic {
		z-index: 20;
		background-color: #21202e;
	}
	
	.navbar-classic {
		min-height: 60px;
	}
	
	.navbar-classic .navbar-nav {
		float: none !important;
	}
	
	.desktop-header .navbar-classic .navbar-nav>li>a {
		color: #fff;
		padding: 20px 25px;
	}
	
	.navbar-classic .navbar-collapse {
		border-top: 1px solid #434158;
	}
	
	.navbar-classic .cart-header {
		width: 25px;
		height: 25px;
		margin: 18px 10px 17px 20px;
	}
	
	.navbar-classic .cart-header>a.cart-icon {
		color: #fff;
		border: 1px solid #ffffff;
	}
	
	.navbar-classic .cart-header>a.cart-icon {
		width: auto;
		height: auto;
		border: 0 none;
		padding: 0;
	}
	
	.navbar-classic .cart-header>a .cart-total {
		right: -11px;
		top: -4px;
	}
	
	.header-widget-info .navbar-brand {
		height: auto;
		padding: 15px 0px;
	}
	/*--------------------------------------------------------------
	Menubar - Media Queries
--------------------------------------------------------------*/
	
	@media (min-width: 768px) {
		.navbar-custom .navbar-brand {
			padding: 20px 50px 20px 0;
		}
		/* Navbar Classic */
		.navbar-classic .navbar-nav {
			float: none !important;
		}
	}
	/*-------------------------------------------------------------------------
/* Navbar - Logo Right Align with Menu
-------------------------------------------------------------------------*/
	
	@media (min-width: 1101px) {
		.navbar-header.align-right {
			float: right;
		}
		.navbar-header.align-right~.navbar-collapse {
			padding-left: 0;
		}
	}
	
	@media (max-width: 1100px) {
		.navbar-header.align-right .navbar-toggle {
			float: left;
			margin-left: 15px;
		}
	}
	
	.navbar-brand.align-right,
	.site-branding-text.align-right {
		float: right;
		margin-right: 0px;
		margin-left: 50px;
		padding-right: 0px;
	}
	
	@media (max-width: 768px) {
		.navbar-brand.align-right,
		.site-branding-text.align-right {
			padding-right: 15px;
		}
	}
	
	@media (max-width: 500px) {
		.navbar-brand.align-right {
			float: none;
			padding: 10px 15px 30px 15px;
		}
		.site-branding-text.align-right {
			float: none;
			padding: 10px 15px 30px 15px;
			margin-left: 0;
		}
		.navbar-header.align-right .navbar-toggle {
			float: none;
			margin: 30px auto 10px;
		}
	}
	
	.p-lef-right-0 {
		padding-left: 0;
		padding-right: 0;
	}
	/*-------------------------------------------------------------------------
/* Navbar - Logo Center Align with Menu
-------------------------------------------------------------------------*/
	
	.mobile-header-center {
		display: none;
	}
	
	@media (max-width: 1100px) {
		.desktop-header-center {
			display: none !important;
		}
		.mobile-header-center {
			display: block !important;
		}
	}
	
	.navbar-center-fullwidth .container-fluid {
		padding-left: 0px;
		padding-right: 0px;
		width: auto;
	}
	
	@media (min-width: 1101px) {
		.navbar-center-fullwidth .logo-area {
			margin: 0 auto;
			padding: 40px 0;
			text-align: center;
		}
		.navbar-brand.align-center,
		.site-branding-text.align-center {
			float: none;
			padding: 0px;
			display: inline-block;
		}
		.navbar-center-fullwidth .navbar-nav {
			float: none;
			margin: 0 auto;
			display: table;
		}
	}
	
	.navbar-center-fullwidth .navbar-collapse {
		border-top: 1px solid #e9e9e9;
		border-bottom: 1px solid #e9e9e9;
	}
	
	.navbar-center-fullwidth .navbar-nav>.active>a,
	.navbar-center-fullwidth .navbar-nav>.active>a:hover,
	.navbar-center-fullwidth .navbar-nav>.active>a:focus {
		color: #ce1b28 !important;
		background-color: transparent !important;
	}
	
	.navbar-center-fullwidth .navbar-nav li>a {
		padding: 20px;
	}
	
	.navbar-center-fullwidth .dropdown-menu>li>a {
		padding: 12px 15px;
	}
	
	.navbar-center-fullwidth .sp-search-area {
		margin-top: 10px;
		margin-bottom: 8px;
	}
</style>


// WEBPACK FOOTER //
// src/components/home.vue